module.exports = __webpack_public_path__ + "media/images/take-photo-btn-c4f577a8d930ccf992c729bce6e99cbe21567ff065a8eae4d7cf022ec5f04dfc.png";